export default __webpack_public_path__ + "static/connectAppleStoreButton-334d542cf0d3691afeb19bc5681afe43.svg";